<div class="wrapper">
    <div class="row table-toolbar">
        <div class="cal-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div class="advancedSearch">
                <mat-form-field floatLabel='never'>
                    <input type="text" name="serach" id="serach" autocomplete="off" matInput [formControl]="advanceSearchCtrl" placeholder="Search">
                    <mat-icon svgIcon="filter" matPrefix></mat-icon>
                </mat-form-field>
            </div>
        </div>
        <div class="cal-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-paginator #paginator [length]="page_length" [pageSize]="items_per_page" [pageSizeOptions]="PAGE_SIZE_OPTIONS_DATA" (page)="handlePage($event)"></mat-paginator>
        </div>
        <div class="cal-xl-2 col-lg-2 col-md-12 col-sm-12">
            <div class="button-group">
                <button type="button" (click)="createOrganization()" class="btn-int-blue" mat-raised-button>Create Organization</button>
                <!-- <button type="button" class="btn-int-purple" mat-raised-button>import Organization</button> -->
            </div>

        </div>
    </div>
    <div class="row">
        <div class="cal-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="mat-table-responsive">
                <table mat-table [dataSource]="organizationsDataSource" matSort>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                        <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="int_plan_id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Plan </th>
                        <td mat-cell *matCellDef="let element"> {{(element?.int_plan_id ===1)? 'Go': (element?.int_plan_id ===2)?'Grow':'Pro'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="added_date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Created Date </th>
                        <td mat-cell *matCellDef="let element"> {{element?.added_date}} </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="organizationsDisplayedColumns;sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: organizationsDisplayedColumns;"></tr>
                </table>
                <app-table-loader></app-table-loader>

            </div>
            <!-- <ng-template #noRecord>
                <div class="table-no-date">
                    No Record found
                </div>
            </ng-template> -->
        </div>
    </div>
</div>